import { cn } from '@/lib/utils';

interface MainCardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  contentClassName?: string;
}

export default function MainCard({ children, className, contentClassName, ...props }: MainCardProps) {
  return (
    <div
      className={cn(
        'rounded-lg border border-border/60 bg-card text-card-foreground',
        className
      )}
      {...props}
    >
      <div className={cn('p-4 sm:p-5', contentClassName)}>
        {children}
      </div>
    </div>
  );
}
